<template>
  <div>
    <div class="metric-list" v-if="!metrics.length">
      <MetricItem
        v-for="index in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
        :key="index"
      />
    </div>
    <div class="metric-list" v-if="metrics.length && !questionsStatus">
      <MetricItem
        v-for="metric in metrics"
        :metricType="metricType"
        :key="metric.id"
        :metric="metric"
        :canViewMetricsInfo="canViewMetricsInfo"
      />
    </div>
    <div v-if="metrics.length && questionsStatus">
      <MetricItemWithQuestion
        v-for="(metric, index) in metrics"
        :key="metric.id"
        :metric="metric"
        :index="index"
        :metricsSize="metrics.length"
      />
    </div>
  </div>
</template>

<script>
import MetricItem from './MetricItem.vue'
import MetricItemWithQuestion from './MetricItemWithQuestion.vue'

const props = {
  list: {
    require: true,
    type: Array,
  },
  metricType: {
    require: false,
    type: String,
    default: 'list',
  },
  questionsStatus: {
    require: false,
    type: Boolean,
    default: false,
  },
  canViewMetricsInfo: {
    require: true,
    type: Boolean,
  },
}

export default {
  components: { MetricItem, MetricItemWithQuestion },
  props: props,
  computed: {
    metrics: function() {
      return this.list || []
    },
  },
  beforeDestroy: function() {
    if (this.list) {
      this.list.length = 0
    }
  },
}
</script>

<style lang="scss" scoped>
.metric-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
</style>
